import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

import {
  types as actions,
  setFiltersAction
} from '../../reducers/actions';
import { TagService } from '../../services';

export default function(action$) {   
  return action$.pipe(
    ofType(actions.GET_FILTERS),
    switchMap(action => {
      return TagService.getFiltersBySiteId(action.siteId)
      .pipe(
        map(filters => {
          return setFiltersAction(filters)
        }),
        catchError(retryAuthentication(action$, 'epics/tags/getFilters'))
      );
    })
  );
}



// WEBPACK FOOTER //
// ./src/epics/tags/getFilters.js